import React, { useRef } from 'react';
import { ZoomIn, ZoomOut } from 'lucide-react';
import { TextoRodante } from '../utils/motion';

/**
 * Zoom con lupa (Gantt y Roadmap): aleja o acerca de a una escala y la camara
 * hace el viaje. El nombre de la escala rueda hacia el lado del zoom: sube al
 * acercar, baja al alejar.
 *
 * orden: escalas de menos a más zoom. escalas: { [zoom]: { label } }.
 */
const ControlZoom = ({ zoom, orden, escalas, onCambiar }) => {
  const indice = orden.indexOf(zoom);
  const previo = useRef(indice);
  const direccion = useRef(1);
  if (previo.current !== indice) {
    direccion.current = indice > previo.current ? 1 : -1;
    previo.current = indice;
  }
  const paso = (d) => {
    const siguiente = Math.max(0, Math.min(orden.length - 1, indice + d));
    if (siguiente !== indice) onCambiar(orden[siguiente]);
  };
  const boton = 'p-1 text-slate-400 hover:text-slate-800 hover:bg-slate-100 rounded transition-colors disabled:opacity-40 disabled:cursor-not-allowed';
  return (
    <div className="inline-flex items-center gap-0.5" role="group" aria-label="Zoom de la línea de tiempo">
      <button onClick={() => paso(-1)} disabled={indice <= 0} title="Menos zoom" className={boton}>
        <ZoomOut size={14} />
      </button>
      <span className="min-w-[64px] flex justify-center text-xs text-slate-500">
        <TextoRodante valor={escalas[zoom].label} direccion={direccion.current} />
      </span>
      <button onClick={() => paso(1)} disabled={indice >= orden.length - 1} title="Más zoom" className={boton}>
        <ZoomIn size={14} />
      </button>
    </div>
  );
};

export default ControlZoom;
